'use strict'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import HelpLink from '../HelpLink/HelpLink'

class CategoryMenuPanel extends PureComponent {
  render () {
    const ccn = 'category-panel'
    const { id, title, links, icon } = this.props

    if (!id) return null

    return (
      <div data-test={ccn + '-' + id} className={ccn} key={id}>
        <div className={ccn + '__header'}>
          <h2 className={ccn + '__title ' + ccn + '__title--' + id}>
            {title}
            <span className={ccn + '__icon argos-icon ' + icon} />
          </h2>
        </div>
        <div className={ccn + '__menu'}>
          <ul className={ccn + '__menu__list'}>
            {links.map((link, index) => {
              let linkNum = (index + 1)
              if (link.target) {
                return (
                  <li key={index}>
                    <HelpLink className={ccn + '__link '} href={link.link} target={link.target} data-test={ccn + '__link--' + id + '-' + linkNum}>
                      {link.name}
                      <span className={ccn + '__link--icon'} aria-hidden='true' />
                    </HelpLink>
                  </li>
                )
              }
              return (
                <li key={index}>
                  <HelpLink className={ccn + '__link '} href={link.link} data-test={ccn + '__link--' + id + '-' + linkNum}>
                    {link.name}
                    <span className={ccn + '__link--icon'} aria-hidden='true' />
                  </HelpLink>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }
}

CategoryMenuPanel.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  links: PropTypes.array,
  icon: PropTypes.string
}

export default CategoryMenuPanel
